import { createAsyncThunk } from '@reduxjs/toolkit';
import { uniq } from 'lodash';
import { getSubcontractorRecordsData } from 'scenes/WorkDemo/services/getSubcontractorRecordsData.service';
import { loadAssignmentsForProjects } from 'store/assignments/thunks/loadAssignmentsForProjects';
import { loadShadowRecordsForRecords } from 'store/shadowData/thunks/loadShadowRecordsForRecords.thunk';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadSubcontractorRecordsData = createAsyncThunk(
  'workCalendar/loadSubcontractorRecordsData',
  async (_, { getState, dispatch }) => {
    const { workSearchParams_demo } = getState();

    const selectedProjectId = selectSelectedProjectId(getState());

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());
    const fromDate = workSearchParams_demo.fromDate;
    const toDate = workSearchParams_demo.toDate;

    const response = await getSubcontractorRecordsData(
      selectedProjectId,
      fromDate,
      toDate,
      activeEmployerInfo
    );

    const recordsProjectIds = uniq(
      (response.records || [])
        .filter((record) => record.assignment)
        .map((record) => record.project)
    );

    dispatch(loadAssignmentsForProjects(recordsProjectIds));

    const recordIds = (response.records || []).map((record) => record.id);
    dispatch(loadShadowRecordsForRecords(recordIds));

    return response;
  }
);
